import { MainPage } from './MainPage';

// oxlint-disable-next-line import/no-default-export
export default MainPage;
